import { symbol } from "./symbol.js";
<ebay-icon ...input _name="radio-unchecked-18" _size="18" _type="icon" _themes=symbol/>